import { createAsyncThunk } from '@reduxjs/toolkit'
import { ClubSanctionListApi } from './ClubSanction.services'
import { paginationData } from '../Pagination/reducers'

//services
export const ClubSanctionList = createAsyncThunk(
    'Club/Membership/List',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await ClubSanctionListApi(data)

            if (data._limit) {
                // Pagination Section
                const limit = data._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
